import React, { useState } from "react";
import { Modal, Button, Form, ListGroup, InputGroup } from "react-bootstrap";

const ManageTagsModal = ({ show, handleClose, tags, addTag, deleteTag }) => {
  const [newTag, setNewTag] = useState("");

  const handleAddTag = () => {
    const trimmedTag = newTag.trim();
    if (trimmedTag && !tags.includes(trimmedTag)) {
      addTag(trimmedTag);
      setNewTag("");
    } else if (tags.includes(trimmedTag)) {
      alert("このタグは既に存在します。");
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAddTag();
    }
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>タグ管理</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ListGroup className="mb-3">
          {tags.map((tag) => (
            <ListGroup.Item
              key={tag}
              className="d-flex justify-content-between align-items-center"
            >
              {tag}
              <Button variant="danger" size="sm" onClick={() => deleteTag(tag)}>
                削除
              </Button>
            </ListGroup.Item>
          ))}
        </ListGroup>
        <InputGroup>
          <Form.Control
            type="text"
            placeholder="新しいタグ名"
            value={newTag}
            onChange={(e) => setNewTag(e.target.value)}
            onKeyPress={handleKeyPress}
          />
          <Button variant="primary" onClick={handleAddTag}>
            追加
          </Button>
        </InputGroup>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          閉じる
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ManageTagsModal;
